export default {
  "nav.thesis": "These",
  "nav.disciplines": "Disziplinen",
  "nav.horizon": "Horizont",
  "nav.join": "Bewerben",
  "nav.backus": "Abonnieren",
  "nav.invest": "Unterstützen",

  "hero.badge": "Ingenieurskunst für Langlebigkeit",
  "hero.l1": "Menschliche Unsterblichkeit ist theoretisch.",
  "hero.l2": "150 Jahre sind praktisch.",
  "hero.sub": "Langlebigkeit ist eine multidisziplinäre menschliche Herausforderung. Medizin und Gesundheitswissenschaften haben bemerkenswerte Fortschritte in der Langlebigkeit vorangetrieben. Die nächsten Durchbrüche könnten aus ihrer Konvergenz mit Ingenieurwesen, KI, Neurologie, Psychologie, Kognitionswissenschaft, Quantenmechanik, Teilchenphysik und Raumzeit entstehen.",
  "hero.sub2": "The Lifespan Project bringt diese Disziplinen zusammen. Nichts in den bekannten Gesetzen der Physik scheint ein weitaus längeres menschliches Leben zu verbieten. Wir wollen untersuchen und beweisen, was möglich ist.",
  "hero.cta1": "Projekt abonnieren",
  "hero.cta2": "These lesen",
  "hero.stats1": "09 Disziplinen",
  "hero.stats2": "Subliminale Skala",
  "hero.stats3": "Erste Lösungen ≤ 24 Monate",
  "hero.caption": "Forschung auf subliminaler Skala läuft",

  "mq.1": "Raumzeit",
  "mq.2": "Teilchenphysik",
  "mq.3": "Quantenmechanik",
  "mq.4": "KI-Computing",
  "mq.5": "Biologie",
  "mq.6": "Neurologie",
  "mq.7": "Psychologie",
  "mq.8": "Kognitionswissenschaft",
  "mq.11": "Gesundheitswissenschaften",
  "mq.12": "Medizinische Wissenschaft",
  "mq.9": "Langlebigkeit",
  "mq.10": "150+ Jahre",

  "mani.eyebrow": "Das Manifest",
  "mani.h2a": "Der Tod ist das älteste",
  "mani.h2b": "ungelöste Problem",
  "mani.h2c": "der Physik.",
  "mani.c1t": "Die These",
  "mani.c1b": "Altern ist kein Naturgesetz; es ist ein ungelöstes Ingenieursproblem. Wir glauben fest daran, dass der Mensch theoretisch Unsterblichkeit erreichen kann und praktisch eine Lebensspanne jenseits von 150 Jahren, in naher Zukunft. Jede Disziplin, die wir berühren, weist in dieselbe Richtung.",
  "mani.c2t": "Die Methode",
  "mani.c2b": "Unsere Forschungs- und Rechenprogramme laufen auf subliminaler Skala: unterhalb des Rauschens, über den gesamten Stack von Materie und Geist. Von Teilchenwechselwirkungen bis zur neuronalen Berechnung modellieren wir Leben als ein System, das verstanden, simuliert und erweitert werden kann.",
  "mani.c3t": "Der Horizont",
  "mani.c3b": "Dies ist kein Jahrhundertprojekt. Innerhalb der nächsten zwei Jahre bringen wir unsere ersten Lösungen heraus; die ersten Artefakte eines viel größeren Programms. Was folgt, verzinst sich.",
  "mani.c4t": "Das Modell",
  "mani.c4b": "Unsere Forschung wird von einem breiten Ökosystem getragen: Förderer, Investoren, akademische Abonnenten, Philanthropen, vermögende Privatpersonen, Unternehmer, Partnerfirmen und Sponsoren. Produkte und Dienstleistungen fließen durch The Lifespan Labs, um die Forschung in Gang zu halten; sie sind der Motor, niemals der Zweck.",

  "disc.eyebrow": "Der Stack",
  "disc.h2a": "Neun Disziplinen.",
  "disc.more": "Wie sie konvergiert",
  "disc.converge": "Medizin × Physik × Langlebigkeit",
  "disc.h2b": "Eine Variable.",
  "disc.sub": "Langlebigkeit ist nicht nur ein Problem der Biologie. Es ist ein Full-Stack-Problem, von Teilchen bis zum Bewusstsein.",
  "disc.d1n": "Raumzeit und Materie",
  "disc.d1d": "Leben entfaltet sich in einem physikalischen Gefüge. Wir untersuchen, wie Materie sich über die Zeit organisiert, beharrt und repariert.",
  "disc.d1x": "Die Medizin misst das Altern in Jahren; die Physik fragt, was Zeit selbst ist. Indem wir untersuchen, wie Materie sich in Raumzeit organisiert und erhält, suchen wir nach den tiefsten Hebeln, die lebende Systeme dem Verfall widerstehen lassen.",
  "disc.d2n": "Teilchenphysik",
  "disc.d2d": "Auf den kleinsten Skalen liegen die Regeln, denen alles andere gehorcht.",
  "disc.d2x": "Jedes Medikament, jede Zelle und jeder Gedanke besteht aus Teilchen, die präzisen Regeln folgen. Diese Regeln auf den kleinsten Skalen zu verstehen, ermöglicht der Medizin Eingriffe mit atomarer Genauigkeit statt Annäherung.",
  "disc.d3n": "Quantenmechanik",
  "disc.d3d": "Kohärenz, Dekohärenz und die quantenphysikalische Basis der biologischen Maschinerie.",
  "disc.d3x": "Leben läuft bereits auf Quantenmaschinerie: Enzyme, Photosynthese und möglicherweise Kognition. Wo Medizin auf Quantenphysik trifft, erforschen wir Kohärenz, Tunneleffekt und Sensorik als neue Werkzeuge, um Biologie zu lesen und zu reparieren.",
  "disc.d4n": "KI und Computing",
  "disc.d4d": "Simulation und maschinelle Intelligenz komprimieren Jahrzehnte biologischer Versuche auf Tage von Rechenzeit.",
  "disc.d4x": "KI komprimiert Jahrzehnte medizinischen Ausprobierens in Tage der Simulation. Gepaart mit physikalischen Modellen des Körpers können wir Moleküle und Therapien in silico testen, bevor sie je einen Patienten erreichen.",
  "disc.d5n": "Biologie",
  "disc.d5d": "Zellreparatur, Seneszenz und Regeneration: die direkten Hebel der Lebensspanne.",
  "disc.d5x": "Biologie liefert der Medizin ihre Ziele: Zellreparatur, Seneszenz und Regeneration. Kombiniert mit Messungen auf physikalischem Niveau wird Altern von einem Rätsel zu einer Ingenieursspezifikation.",
  "disc.d6n": "Neurologie",
  "disc.d6d": "Das Gehirn ist der unersetzliche Kern. Es zu schützen und zu erweitern ist nicht verhandelbar.",
  "disc.d6x": "Das Gehirn ist der Ort, an dem die Medizin noch nicht ersetzen kann, was versagt. Neurologie konvergiert mit Physik und Informatik, um den unersetzlichen Kern dessen, wer wir sind, zu schützen, zu verbinden und eines Tages zu erweitern.",
  "disc.d7n": "Psychologie und Kognitionswissenschaft",
  "disc.d7d": "Ein längeres Leben muss ein lebenswertes Leben bleiben: Geist, Gedächtnis und Sinn inklusive.",
  "disc.d7x": "Ein längeres Leben zählt nur, wenn der Geist gedeiht. Kognitionswissenschaft und Medizin kartieren gemeinsam, wie Gedächtnis, Motivation und Sinn sich mit dem Alter verändern, damit gewonnene Jahre lebenswert bleiben.",
  "disc.d8n": "Gesundheitswissenschaften",
  "disc.d8d": "Öffentliche Gesundheit, Ernährung und Prävention, die Hebel auf Bevölkerungsebene, die dem menschlichen Leben bereits Jahrzehnte hinzugefügt haben.",
  "disc.d8x": "Die öffentliche Gesundheit hat dem menschlichen Leben Jahrzehnte hinzugefügt, ganz ohne Pille: Sanitärversorgung, Ernährung, Prävention. Mit physikalischer Präzision gemessen, werden diese Bevölkerungshebel zu programmierbarer Infrastruktur für Langlebigkeit.",
  "disc.d9n": "Medizinische Wissenschaft",
  "disc.d9d": "Die klinische Medizin überführt die Langlebigkeitsforschung in die Praxis: Diagnostik, Therapien und Versorgung, die gesunde Jahre verlängern.",
  "disc.d9x": "Medizin überführt jede Entdeckung in die Praxis. In Konvergenz mit Physik und Ingenieurwesen gewinnen Diagnostik, Bildgebung und Therapien die Auflösung, Altern früh zu erkennen und präzise umzukehren.",

  "time.eyebrow": "Der Horizont",
  "time.h2a": "Zwei Jahre bis zu den",
  "time.h2b": "ersten Lösungen.",
  "time.m1t": "Jetzt",
  "time.m1h": "Forschung auf Subliminaler Skala",
  "time.m1b": "Tiefe Forschungs- und groß angelegte Rechenprogramme laufen bereits, leise, unter dem Radar, quer durch Physik, KI und Biologie.",
  "time.m2t": "T + 12 Monate",
  "time.m2h": "Erste Kandidaten-Interventionen",
  "time.m2b": "Die frühesten validierten Ergebnisse des Programms gehen von der Simulation in die strukturierte Bewertung über.",
  "time.m3t": "T + 24 Monate",
  "time.m3h": "Erste Lösungen werden ausgerollt",
  "time.m3b": "Unsere ersten Lösungen gehen live. Der Anfang einer sich verzinsenden Pipeline hin zur radikalen Verlängerung der Lebensspanne.",
  "time.outro": "Bleiben Sie dran. Die Uhr läuft bereits.",

  "pipe.eyebrow": "Die Pipeline",
  "pipe.h2a": "Von der Grundlagenforschung zu",
  "pipe.h2b": "Lösungen für die reale Welt.",
  "pipe.s1t": "Grundlagenforschung",
  "pipe.s1tail": "und verwandte Disziplinen.",
  "pipe.s2t": "Modelle und Entdeckung",
  "pipe.s3t": "Technologie",
  "pipe.s4t": "The Lifespan Labs",
  "pipe.s4d": "Ein kuratiertes Ökosystem aus Produkten und Dienstleistungen für ein gesünderes, längeres und besseres Leben.",
  "pipe.s5t": "Das Ökosystem des längeren Lebens",
  "pipe.s5tail": "und langlebigkeitsorientierte Lösungen.",

  "back.eyebrow": "Das Programm",
  "back.h2a": "Zuerst die",
  "back.h2b": "Gleichung der Unsterblichkeit.",
  "back.h2c": "Dann alles, was sie freischaltet.",
  "back.badge": "Beweis vor Produkt",
  "back.copy": "Unsere Kernarbeit ist mathematisch: ein physikalisch fundierter Beweis, die Gleichung der Unsterblichkeit, der formalisiert, warum biologische Zeit angehalten und umgekehrt werden kann. Jede Lösung, die wir bauen, folgt daraus.",
  "back.cta1": "Projekt abonnieren",
  "back.cta2": "Unterstützen",

  "sub.eyebrow": "Bleiben Sie nah an der Forschung",
  "sub.h2a": "Updates abonnieren.",
  "sub.h2b": "Der Gemeinschaft beitreten.",
  "sub.p": "Forschungsnachrichten, Publikationen und Ökosystem-Updates, direkt in Ihr Postfach. Jeder neue Abonnent erhält eine Digitale Mitgliedskarte als Prime Member, mit dem ersten Monat kostenlos.",
  "sub.success.h": "Willkommen in der Gemeinschaft.",
  "sub.success.p": "Ihre Digitale Mitgliedskarte als Prime Member finden Sie unten, und eine Kopie ist unterwegs in Ihr Postfach, mit Ihrem ersten Monat kostenlos.",
  "sub.download": "Mitgliedskarte herunterladen",
  "sub.submit": "Updates abonnieren",
  "sub.sending": "Abonnieren...",

  "form.name": "Vollständiger Name",
  "form.email": "E-Mail",
  "form.phone": "Kontaktnummer",
  "form.country": "Land",
  "form.city": "Stadt",
  "form.ph.name": "Ihr Name",
  "form.ph.country": "Indien",
  "form.ph.city": "Mumbai",
  "form.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie an invest@thelifespanproject.com.",
  "form.sending": "Wird gesendet...",

  "footer.desc": "Eine multidisziplinäre Forschungsinitiative für menschliche Langlebigkeit, die die nächsten 150 Jahre menschlichen Lebens gestaltet.",
  "footer.explore": "Entdecken",
  "footer.contact": "Kontakt",
  "footer.legal": "Rechtliches",
  "footer.terms": "Bedingungen",
  "footer.privacy": "Datenschutzerklärung",
  "footer.refund": "Erstattungsrichtlinie",
  "footer.faq": "Häufige Fragen",
  "footer.partners": "Technologiepartner und Förderer",
  "footer.copyright": "© 2026 The Lifespan Project. Alle Rechte vorbehalten.",
  "footer.tagline": "Unsterblichkeit ist theoretisch. 150 Jahre sind praktisch.",

  "pick.title": "Wählen Sie Ihre Ansicht",
  "pick.sub": "Wählen Sie ein Theme zum Starten. Sie können es jederzeit im Header ändern.",
  "pick.dark": "Dunkel",
  "pick.dark.sub": "Cinematisch",
  "pick.light": "Hell",
  "pick.light.sub": "Weiß-Verlauf",

  "cookie.text": "Diese Website verwendet essenzielle Cookies und datenschutzfreundliche Analysen. Indem Sie fortfahren, erkennen Sie unsere",
  "cookie.accept": "Verstanden",

  "inv.badge": "Investorenbeziehungen",
  "inv.h1a": "Investieren Sie in die",
  "inv.h1b": "nächsten 150 Jahre.",
  "inv.sub": "The Lifespan Project ist eine multidisziplinäre Forschungsinitiative für menschliche Langlebigkeit. Sagen Sie uns, wer Sie sind, und unser Team meldet sich mit dem vollständigen Investorenbriefing.",
  "inv.perks.h": "Was Investoren erhalten",
  "inv.perk1": "Vollständiges Investorenbriefing und Forschungs-Roadmap",
  "inv.perk2": "Direkter Draht zum Gründerteam",
  "inv.perk3": "Datenraum und technische Dokumentation auf Anfrage",
  "inv.perk4": "Früher Einblick in die Lösungs-Pipeline",
  "inv.next.h": "Wie es weitergeht",
  "inv.next.p": "Sie erhalten sofort eine Bestätigung im Markendesign mit einer Kopie Ihrer Anfrage. Unser Team meldet sich anschließend persönlich mit dem Investorenbriefing. Lieber per E-Mail? Schreiben Sie an",
  "inv.org": "Organisation",
  "inv.ph.org": "Fonds, Institution oder Unternehmen",
  "inv.interest": "Ihr Interesse",
  "inv.ph.interest": "Ticketgröße, Mandat, Zeitrahmen...",
  "inv.submit": "Investorenbriefing anfordern",
  "inv.success.h": "Danke, Anfrage erhalten.",
  "inv.success.p": "Eine Bestätigung mit einer Kopie Ihrer Anfrage ist unterwegs in Ihr Postfach. Unser Team meldet sich in Kürze.",

  "join.badge": "Arbeiten Sie mit uns",
  "join.h1a": "Werden Sie",
  "join.h1b": "Kollaborateur im Labor.",
  "join.sub": "Wir arbeiten mit außergewöhnlichen Forschern, Klinikern und Fachleuten als Praktikanten und Kollaborateure, an der Gleichung der Unsterblichkeit und allem, was sie freischaltet.",
  "join.elig.h": "Mindestvoraussetzungen",
  "join.elig1": "Doktorat, PhD, MBBS oder MD",
  "join.elig2": "Oder Doppelmajor-Postgraduation in beliebigem Fach",
  "join.elig3": "Derzeit berufstätig, überall",
  "join.elig4": "Mindestens 5 Jahre Erfahrung, in Indien oder im Ausland",
  "join.next.h": "Wie es weitergeht",
  "join.next.p": "Jede Bewerbung wird von unserem Forschungsteam persönlich geprüft. Sie erhalten sofort eine E-Mail-Kopie Ihrer Einreichung, und wir melden uns bei Passung.",
  "join.qual": "Höchste Qualifikation",
  "join.qual.select": "Qualifikation wählen",
  "join.disc": "Welche Disziplin passt am besten zu Ihnen?",
  "join.disc.select": "Disziplin auswählen",
  "join.disc.unsure": "Noch nicht sicher",
  "join.spec": "Spezialisierung / Fachrichtung",
  "join.ph.spec": "z. B. Quantenbiologie, Neurologie",
  "join.exp": "Jahre Erfahrung",
  "join.ph.exp": "Mind. 5",
  "join.role": "Aktuelle Rolle und Organisation",
  "join.ph.role": "z. B. Wissenschaftlicher Mitarbeiter, CSIR",
  "join.why": "Warum möchten Sie mitarbeiten?",
  "join.ph.why": "Ihre Forschungsinteressen, Publikationen, woran Sie arbeiten würden...",
  "join.ph.country": "Indien / Ausland",
  "join.submit": "Als Kollaborateur bewerben",
  "join.submitting": "Wird gesendet...",
  "join.success.h": "Bewerbung erhalten.",
  "join.success.p": "Eine Kopie Ihrer Einreichung ist unterwegs in Ihr Postfach. Unser Forschungsteam prüft jede Bewerbung persönlich.",

  "bu.badge": "Wir treiben die Wissenschaft der menschlichen Langlebigkeit voran",
  "bu.h1a": "Werden Sie",
  "bu.h1b": "Gründungsmitglied",
  "bu.h1c": "von The Lifespan Project.",
  "bu.sub": "Die Zukunft der menschlichen Langlebigkeit wird nicht von einer einzigen Disziplin, einem einzigen Labor oder einer einzigen Technologie gebaut. Sie entsteht durch Forschung, Experimente, Zusammenarbeit und die Übersetzung wissenschaftlichen Wissens in greifbare Lösungen. Ihre Mitgliedschaft unterstützt diesen Weg.",
  "bu.projline": ": erforscht die Wissenschaft.",
  "bu.labsline": ": erweckt Langlebigkeitslösungen zum Leben.",

  "arch.eyebrow": "Die Struktur",
  "arch.h2a": "Eine Mission.",
  "arch.h2b": "Zwei Motoren.",
  "arch.proj.h": "Wissenschaftliche F&E",
  "arch.labs.h": "Langlebigkeits-Marktplatz",

  "flow.1": "Forschung",
  "flow.2": "Validierung",
  "flow.3": "Technologie",
  "flow.4": "Produkte und Dienste",
  "flow.5": "Längeres, gesünderes Leben",

  "pos.eyebrow": "Was Mitgliedschaft bedeutet",
  "pos.h2": "Sie abonnieren nicht einfach nur Inhalte.",
  "pos.p": "Sie werden Teil der Gründungsgemeinschaft hinter der Forschung. Die Mitgliedschaft unterstützt die laufende Entwicklung von Forschung, wissenschaftlicher Arbeit, Wissen, Experimenten und der zukünftigen Lösungs-Pipeline von The Lifespan Project. Im Gegenzug erhalten Gründungsmitglieder eine Digitale Gründungsmitgliedschaft, die sie mit dem wachsenden Lifespan-Ökosystem verbindet.",
  "pos.note": "Die Mitgliedschaft garantiert kein wissenschaftliches Ergebnis, kein Gesundheitsergebnis und keine Verlängerung der Lebensspanne.",

  "eco.eyebrow": "Digitale Gründungsmitgliedschaft",
  "eco.h2a": "Ihre Mitgliedschaft reicht",
  "eco.h2b": "über die Forschung hinaus.",
  "eco.sub": "Jedes Gründungsmitglied erhält eine Digitale Mitgliedschaft im wachsenden Lifespan-Ökosystem, einschließlich Zugang zum kommenden Marktplatz The Lifespan Labs.",
  "eco.c1n": "Gesundheit",
  "eco.c2n": "Ernährung",
  "eco.c3n": "Biomarker und Labore",
  "eco.c4n": "Ärzte und Gesundheitsdienste",
  "eco.c5n": "Geräte und Maschinen",
  "eco.c6n": "Sport und Körper",
  "eco.c7n": "Heilung und Physiotherapie",
  "eco.c8n": "Geist und Psychologie",
  "eco.c9n": "Geist · Körper · Seele",

  "ben.eyebrow": "Vorteile für Gründungsmitglieder",
  "ben.h": "Was Gründungsmitglieder erhalten",

  "mode.free": "Kostenlos",
  "mode.monthly": "Monatlich",
  "mode.life": "Lebenslang",
  "cad.month": "pro Monat",
  "cad.life": "lebenslang",
  "cad.free": "für immer",
  "cad.month.short": "Monat",
  "reg.intl": "Außerhalb Indiens",
  "reg.in": "Indien",

  "plan.prime.tag": "Der Einstieg in das Lifespan-Ökosystem.",
  "plan.prime.f1": "Digitale Gründungs-Mitgliedskarte mit scanbarem Code",
  "plan.prime.f2": "Alle veröffentlichten Forschungen, Inhalte und Videos",
  "plan.prime.f3": "Zugang zu The Lifespan Labs beim Start",
  "plan.prime.f4": "Mitgliederangebote und Vorzugspreise",
  "plan.prime.f5": "Forschung zur Begutachtung einreichen",
  "plan.pro.tag": "Alles aus Prime, lebenslang. Plus der innere Kreis.",
  "plan.pro.f1": "Lebenslange Mitgliedschaft, keine Verlängerungen",
  "plan.pro.f2": "Pro-exklusive Forschungsveröffentlichungen",
  "plan.pro.f3": "Einladungen zu Forschungstreffen und Events weltweit",
  "plan.pro.f4": "Erhöhte Rabatte bei The Lifespan Labs",
  "plan.pro.f5": "Priorisierter Zugang zu neuen Produkten und Diensten",
  "plan.well.tag": "Bleiben Sie nah an der Wissenschaft, kostenlos.",
  "plan.well.f1": "Digitale Wellwisher-Mitgliedskarte mit Code",
  "plan.well.f2": "Forschungsnachrichten und Updates",
  "plan.well.f3": "Als Erster vom Start von The Lifespan Labs erfahren",

  "cta.subscribe": "Hier abonnieren",
  "cta.free": "Kostenlos abonnieren",
  "cta.welllink": "Kostenlos als Wellwisher abonnieren",

  "why.eyebrow": "Die Begründung",
  "why.h": "Warum Gründungsmitglied werden?",
  "why.1t": "Forschung unterstützen",
  "why.2t": "Zugang zum Ökosystem",
  "why.3t": "Entdecken, was kommt",
  "why.4t": "Die Zukunft mitgestalten",

  "flowS.eyebrow": "Wie es zusammenhängt",
  "flowS.h": "Von der Forschung zur Gemeinschaft",
  "flowS.n1t": "F&E · Wissenschaft · Forschung · Technologie",
  "flowS.n2t": "Produkte · Dienste · Marktplatz · Zugang",
  "flowS.n3t": "Gemeinschaft · Zugang · Teilnahme",
  "flowS.proline": "Pro-Gründungsmitglieder können Einladungen zu ausgewählten Forschungstreffen, Konferenzen und Ökosystem-Veranstaltungen von The Lifespan Project auf der ganzen Welt erhalten.",
  "net.caption": "Globales Forschungsnetzwerk",

  "ck.eyebrow": "Werden Sie Gründungsmitglied",
  "ck.h": "Aktivieren Sie Ihre Mitgliedschaft",
  "ck.submit": "Weiter zur sicheren Zahlung",
  "ck.sending": "Sichere Kasse wird geöffnet...",
  "ck.per.month": " / Monat",
  "ck.per.life": " lebenslang",
  "ck.note1": "Erfasst als",
  "ck.note2": "Abonnement. Quittung und Rechnung folgen per E-Mail.",
  "ck.invite.toggle": "Haben Sie einen Einladungscode?",
  "ck.invite.code": "Einladungscode",
  "ck.invite.sending": "Ihre Einladung wird angewendet...",
  "ck.invite.submit": "Kostenlose Mitgliedschaft einlösen",
  "ck.invite.note": "Mit einem gültigen Code ist der gewählte Plan vollständig kostenlos.",
  "ck.invite.ph": "Code eingeben",
  "ck.inrnote": "Internationale Karten willkommen. Razorpay rechnet in INR zum angezeigten Rupien-Preis ab.",
  "ck.orwell": "Noch nicht bereit, die Forschung zu unterstützen?",

  "close.h2a": "Schauen Sie der",
  "close.h2b": "Zukunft der Langlebigkeit",
  "close.h2c": "nicht nur zu. Helfen Sie, sie zu bauen.",
  "close.p": "The Lifespan Project baut die Forschung. The Lifespan Labs wird das Ökosystem zusammenführen. Gründungsmitglieder helfen, diesen Weg möglich zu machen, und werden Teil dessen, was kommt.",
  "close.prime": "Prime-Mitglied werden",
  "close.pro": "Pro-Mitglied werden",
  "close.or": "oder",

  "res.h2a": "Haben Sie eine Idee?",
  "res.h2b": "Bringen Sie sie ins Projekt.",
  "res.cta": "Reichen Sie Ihre Forschung ein",

  "ww.eyebrow": "Für immer kostenlos",
  "ww.title": "Werden Sie Wellwisher Founding Member",
  "ww.sub": "Forschungsnachrichten und Updates, sowie Ihre Digitale Wellwisher-Mitgliedskarte mit scanbarem Code, sofort geliefert.",
  "ww.success.p": "Willkommen. Ihre Karte finden Sie unten, und eine Kopie ist unterwegs in Ihr Postfach.",
  "ww.submitting": "Abonnieren...",

  "legal.notice": "Dieses Rechtsdokument wird auf Englisch bereitgestellt, um seine exakte Bedeutung zu bewahren.",

  "ui.language": "Sprache",
  "ui.theme": "Design",
};
